<template>
  <div class="jl-subside-wrap">
    <div class="jl-sub-item" v-for="(item, index) in sideNavList" :key="index">
      <div class="jl-sub-item-list">
        <div class="item">
          <i v-if="item.meta.icon" :class="[item.meta.icon?item.meta.icon:'']"></i>
          <a v-if="item.isLoginOut" class="text1" @click="loginOut">{{item.meta.title}}</a>
          <router-link v-else class="text1" :to="item.path">{{item.meta.title}}</router-link>
        </div>
        <template v-if="!item.hideChildMenu">
          <template v-for="(val, i) in item.children">
            <div class="item sub-item" :key="index + i" v-if="!val.hideMenu">
              <router-link
                :class="[$route.path === val.path?'text2 active':'text2']"
                :to="val.path"
                :data="val.hideMenus"
              >{{val.meta.title}}</router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loginOut } from "@/api/user";
export default {
  data() {
    return {
      sideNavList: []
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.sideNavList = this.getSideNav();
  },
  methods: {
    getSideNav() {
      let arr = this.$router.options.routes,
        childArr = [];
      arr.filter(item => {
        if (item.accountMenu === true) {
          childArr = item.children;
        }
      });
      return childArr;
    },
    linkTo(item) {
      if (item.hideChildMenu) {
        this.$router.push({
          path: item.path
        });
      }
    },
    loginOut() {
      loginOut(this, res => {
        if (res.code === 200) {
          this.$store.dispatch("setUserInfo", {});
          localStorage.setItem("token", "");
          this.$message({
            type: "success",
            message: "退出成功"
          });
          this.$router.push({
            name: "login"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-subside-wrap {
  .jl-sub-item {
    padding: 20px 0 0 30px;
    border-bottom: 1px solid #e0e0e0;
    &:last-child {
      border-bottom: none;
    }
  }
  .jl-sub-item-list {
    .item {
      position: relative;
      padding-left: 28px;
      margin-bottom: 20px;
      &.active {
        .text1 {
          color: #e70819;
        }
      }
      i {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &.sub-item .text2 {
        display: block;
        font-size: 14px;
        color: #292929;
        &.active {
          color: #e70819;
        }
      }
    }
    .text1 {
      display: block;
      font-size: 16px;
      color: #292929;
    }
  }
}
@media screen and (min-width: 1200px) {
  .jl-subside-wrap .jl-sub-item-list .item.sub-item .text2:hover {
    color: #e70819;
  }
}
</style>
